import { Catalog } from '@a2ui/web_core/v0_9';
import { Column, type ReactComponentImplementation } from '@a2ui/react/v0_9';
import { RiskScoreCardImpl } from './surfaces/RiskScoreCard/RiskScoreCard.a2ui';
import { ActionButtonImpl } from './surfaces/ActionButton/ActionButton.a2ui';
import { EmailComposerImpl } from './surfaces/EmailComposer/EmailComposer.a2ui';
import { ApplyPaymentImpl } from './surfaces/ApplyPayment/ApplyPayment.a2ui';
import { NoteComposerImpl } from './surfaces/NoteComposer/NoteComposer.a2ui';
import { CopyQuoteImpl } from './surfaces/CopyQuote/CopyQuote.a2ui';
import { QuoteOptionImpl } from './surfaces/CopyQuote/QuoteOption.a2ui';
import { QuoteNoteImpl } from './surfaces/CopyQuote/QuoteNote.a2ui';
import { CreateQuoteImpl } from './surfaces/CreateQuote/CreateQuote.a2ui';
import { CreateQuoteRowImpl } from './surfaces/CreateQuote/CreateQuoteRow.a2ui';
import { FileArtifactCardImpl } from './surfaces/FileArtifactCard/FileArtifactCard.a2ui';
import { ArtifactGroupImpl } from './surfaces/ArtifactGroup/ArtifactGroup.a2ui';
import { ArtifactRowImpl } from './surfaces/ArtifactRow/ArtifactRow.a2ui';
import { EditQuoteImpl } from './surfaces/EditQuote/EditQuote.a2ui';
import { ViewChangeProposalImpl } from './surfaces/ViewChangeProposal/ViewChangeProposal.a2ui';
import { UnderwriterHandoffImpl } from './surfaces/UnderwriterHandoff/UnderwriterHandoff.a2ui';
import { AskQuestionsImpl } from './surfaces/AskQuestions/AskQuestions.a2ui';
import { FormDraftHandoffImpl } from './surfaces/FormDraftHandoff/FormDraftHandoff.a2ui';
import { ClaimReportImpl } from './surfaces/ClaimReport/ClaimReport.a2ui';

// Catalog ID must match the `catalogId` field in createSurface messages.
export const COWBELL_V1_CATALOG_ID = 'cowbell/v1';

export const cowbellV1Catalog = new Catalog<ReactComponentImplementation>(
  COWBELL_V1_CATALOG_ID,
  [
    Column,
    RiskScoreCardImpl,
    ActionButtonImpl,
    EmailComposerImpl,
    ApplyPaymentImpl,
    NoteComposerImpl,
    CopyQuoteImpl,
    QuoteOptionImpl,
    QuoteNoteImpl,
    CreateQuoteImpl,
    CreateQuoteRowImpl,
    // Retained indefinitely: persisted conversations replay envelopes naming it,
    // and AsyncTaskProgress renders the presentational card directly for MooTask
    // delivery. ArtifactGroup/ArtifactRow supersede it for new emissions only.
    FileArtifactCardImpl,
    ArtifactGroupImpl,
    ArtifactRowImpl,
    EditQuoteImpl,
    ViewChangeProposalImpl,
    UnderwriterHandoffImpl,
    AskQuestionsImpl,
    FormDraftHandoffImpl,
    ClaimReportImpl,
  ]
);
